import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Adjust path if needed

const TicketGroup = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedTicketGroup, setSelectedTicketGroup] = useState(null);
  const [ticketGroups, setTicketGroups] = useState([
    { ticketGroup: "Entrance Tickets Foreign", status: "Active", id: 1 },
    { ticketGroup: "Activity Tickets Local", status: "Inactive", id: 2 },
    { ticketGroup: "Entrance Tickets Local", status: "Active", id: 3 },
  ]);

  const [formData, setFormData] = useState({
    ticketGroup: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [ticketGroups]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedTicketGroup) {
      setTicketGroups(
        ticketGroups.map((group) =>
          group.id === selectedTicketGroup.id ? { ...formData, id: group.id } : group
        )
      );
    } else {
      setTicketGroups([
        ...ticketGroups,
        {
          ...formData,
          id: ticketGroups.length ? ticketGroups[ticketGroups.length - 1].id + 1 : 1,
        },
      ]);
    }
    setShowForm(false);
    setFormData({ ticketGroup: "", status: "Active" });
    setSelectedTicketGroup(null);
  };

  const handleEdit = (group) => {
    setSelectedTicketGroup(group);
    setFormData({
      ticketGroup: group.ticketGroup,
      status: group.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedTicketGroup(null);
    setFormData({ ticketGroup: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="ticket-group d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left form */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedTicketGroup ? "Edit Ticket Group" : "Add Ticket Group"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Ticket Group:</label>
              <input
                type="text"
                name="ticketGroup"
                value={formData.ticketGroup}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right table */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Ticket Groups</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Ticket Group
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Ticket Group</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ticketGroups.map((group) => (
                  <tr key={group.id}>
                    <td>{group.ticketGroup}</td>
                    <td>
                      <span
                        className={`badge ${
                          group.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {group.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(group)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketGroup;
